import { render, staticRenderFns } from "./List-driver.vue?vue&type=template&id=5905e2dc"
import script from "./List-driver.vue?vue&type=script&lang=js"
export * from "./List-driver.vue?vue&type=script&lang=js"
import style0 from "./List-driver.vue?vue&type=style&index=0&id=5905e2dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports